"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSize = useSize;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

// Hook to get the size by given element
//
// Changes from the source code:
// 1. Replace the window resize event with ResizeObserver at L29
//
// Refered from: https://github.com/jaredLunde/mini-virtual-list/blob/master/src/use-size.ts#L5
function useSize(ref) {
  var getSize = function getSize() {
    if (ref.current) {
      var _ref$current = ref.current,
          clientWidth = _ref$current.clientWidth,
          clientHeight = _ref$current.clientHeight;

      var _getComputedStyle = getComputedStyle(ref.current),
          paddingTop = _getComputedStyle.paddingTop,
          paddingBottom = _getComputedStyle.paddingBottom,
          paddingLeft = _getComputedStyle.paddingLeft,
          paddingRight = _getComputedStyle.paddingRight;

      return {
        width: clientWidth - parseFloat(paddingTop) - parseFloat(paddingBottom),
        height: clientHeight - parseFloat(paddingLeft) - parseFloat(paddingRight)
      };
    }

    return {
      width: 0,
      height: 0
    };
  };

  var _useState = (0, _react.useState)(getSize),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var handleResize = function handleResize() {
    return setSize(getSize);
  };

  (0, _react.useEffect)(function () {
    var observer = new _resizeObserverPolyfill["default"](function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
          entry = _ref2[0];

      requestAnimationFrame(handleResize);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return function () {
      observer.disconnect();
    };
  }, [ref.current]);
  return size;
}
//# sourceMappingURL=size.js.map